import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { apiRequest, queryClient } from '@/lib/query-client';

const INVITE_STORAGE_KEY = 'ch_firm_invite';

export function readStoredFirmInvite(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(INVITE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function persistFirmInviteToken(token: string) {
  localStorage.setItem(INVITE_STORAGE_KEY, token);
  document.cookie = `ch_firm_invite=${encodeURIComponent(token)}; path=/; max-age=3600; SameSite=Lax`;
}

export function clearFirmInviteToken() {
  try {
    localStorage.removeItem(INVITE_STORAGE_KEY);
  } catch {
    // ignore
  }
  document.cookie = 'ch_firm_invite=; path=/; max-age=0; SameSite=Lax';
}

export function AcceptFirmInvite() {
  const { isAuthenticated } = useAuth();
  const attempted = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || attempted.current) return;
    const token = readStoredFirmInvite();
    if (!token) return;
    attempted.current = true;
    apiRequest('POST', '/api/firm-invites/accept', { token })
      .then(() => queryClient.invalidateQueries({ queryKey: ['user-profile'] }))
      .catch(() => undefined)
      .finally(() => {
        clearFirmInviteToken();
      });
  }, [isAuthenticated]);

  return null;
}
